import { render } from "./EmailVerification.vue?vue&type=template&id=75e0cca3&scoped=true"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"

import "./EmailVerification.vue?vue&type=style&index=0&id=75e0cca3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e0cca3"]])

export default __exports__